// extracted by mini-css-extract-plugin
export default {"melodyVideo":"tJ-z","isFullWidth":"uJ-z","landingPageVideo":"vJ-z","play":"wJ-z","iframeVideo":"xJ-z","playHidden":"yJ-z","fullwidth":"zJ-z"};